import { render, staticRenderFns } from "./EditLinkedDeviceDialog.vue?vue&type=template&id=470e83dc"
import script from "./EditLinkedDeviceDialog.vue?vue&type=script&lang=js"
export * from "./EditLinkedDeviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports